module.exports = __webpack_public_path__ + "static/rituparna-0b95d9283a68d60c5e04d27d06fe20d8.jpg";